<div class="dynamic-field-container" [class.selected]="config?.selected">
  <div
    class="dynamic-field form-input text-align"
    [formGroup]="group"
    [hidden]="!config?.isFormBuilder && config?.options?.hidden"
  >
    <ups-dynamic-helper-label
      [config]="config"
      [dynamicService]="dynamicService"
    ></ups-dynamic-helper-label>
    <div class="job-search-container" style="position: relative">
      @if (!config?.options?.isMultiSelect) {
        <kendo-dropdownlist
          #dropdown
          class="k-no-dropdown w-100"
          [attr.name]="config.formControlName"
          [formControlName]="config.formControlName"
          [valuePrimitive]="false"
          [textField]="'Name'"
          [valueField]="'Name'"
          [defaultItem]="{ Name: config?.placeholder }"
          [filterable]="true"
          (valueChange)="valueChangeItem($event)"
          search-ex
          [seSearchColumns]="['Name']"
          [itemDisabled]="itemDisabled"
          (seFilterChangeEx)="filterChangeItem($event)"
          [seDebounceFilterChange]="150"
          [seUseCustomLocalFilter]="true"
          [seMinSearchLength]="0"
          [loading]="isLoading"
          [tabindex]="tabindex"
          [listHeight]="config?.options?.listHeight ?? 200"
          [popupSettings]="{ width: config?.options?.popupWidth }"
        >
          <ng-template kendoDropDownListItemTemplate let-dataItem>
            @let itemHint =
              dataItem | dynamicItemHint: config?.options?.itemHint;
            <div
              style="display: inline-flex"
              [class.k-state-disabled]="dataItem?.Name === config?.placeholder"
              [attr.title]="itemHint"
            >
              <div>
                <span [hidden]="!displayIdPrefix">
                  {{
                    dataItem?.Description
                      ? dataItem?.Description
                      : dataItem?.Id
                  }}&nbsp;
                </span>
                <span
                  [class.link-style]="dataItem?.Name !== config?.placeholder"
                >
                  @if (
                    dataItem?.Active === 'false' &&
                    dataItem?.Name !== config.placeholder
                  ) {
                    <span style="color: red">
                      {{ dataItem?.Name }}
                    </span>
                  }
                  @if (!dataItem?.Active || dataItem.Active === 'true') {
                    <span>
                      {{ dataItem?.Name }}
                    </span>
                  }
                </span>
              </div>
            </div>
          </ng-template>
          <ng-template kendoDropDownListValueTemplate let-dataItem>
            <div style="display: inline-flex">
              <div kendoTooltip [title]="dataItem?.Name">
                <span [hidden]="!displayIdPrefix">
                  @if (dataItem?.Description) {
                    {{ dataItem?.Description + ' - ' }}
                  }
                  @if (!dataItem?.Description && dataItem?.Id) {
                    {{ dataItem?.Id ? dataItem?.Id + ' - ' : '' }}
                  }
                </span>
                <span>{{ dataItem?.Name }}</span>
              </div>
            </div>
          </ng-template>
        </kendo-dropdownlist>
      }
      @if (config?.options?.isMultiSelect) {
        <kendo-multiselect
          upsKeepSelectionOnEsc
          [attr.name]="config.formControlName"
          [formControlName]="config.formControlName"
          class="k-no-dropdown w-100"
          [valuePrimitive]="false"
          [textField]="'Name'"
          [valueField]="'Id'"
          [placeholder]="config?.placeholder"
          [filterable]="true"
          (valueChange)="multiSelectValueChange($event)"
          search-ex
          [seSearchColumns]="['Name']"
          (seFilterChangeEx)="filterChangeItem($event)"
          [seDebounceFilterChange]="150"
          [seUseCustomLocalFilter]="true"
          [seMinSearchLength]="0"
          [loading]="isLoading"
          [tabindex]="tabindex"
        >
          <ng-template kendoMultiSelectItemTemplate let-dataItem>
            <div
              style="display: inline-flex"
              [hidden]="dataItem?.Name === config?.placeholder"
            >
              <div>
                <span [hidden]="!displayIdPrefix">
                  {{
                    dataItem?.Description
                      ? dataItem?.Description
                      : dataItem?.Id
                  }}&nbsp;
                </span>
                <span class="job-name link-style">{{ dataItem?.Name }}</span>
              </div>
            </div>
          </ng-template>
          <ng-template kendoMultiSelectValueTemplate let-dataItem>
            <div style="display: inline-flex">
              <div kendoTooltip [title]="dataItem?.Name">
                <span [hidden]="!displayIdPrefix">
                  @if (dataItem?.Description) {
                    {{ dataItem?.Description + ' - ' }}
                  }
                  @if (!dataItem?.Description && dataItem?.Id) {
                    {{ dataItem?.Id ? dataItem?.Id + ' - ' : '' }}
                  }
                </span>
                <span>{{ dataItem?.Name }}</span>
              </div>
            </div>
          </ng-template>
        </kendo-multiselect>
      }
    </div>
    <ups-dynamic-search-error [show]="searchError"></ups-dynamic-search-error>
    @if (config?.isFormBuilder) {
      <div
        class="form-builder-mask"
        [class.hidden]="config?.options?.hidden"
      ></div>
    }
  </div>
  @if (config?.isFormBuilder) {
    <div class="form-builder-options">
      <i class="fas fa-times ms-3 cursor-pointer c-red" (click)="delete()"></i>
      <!-- <i class="fas fa-bars ms-3 cursor-grab"></i> -->
    </div>
  }
</div>
